import { getConfig } from '@cian/config/browser';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

import { getTeaserApiUrl } from '../../utils/tracking/getTeaserApiUrl';

export interface ITeaserEventProps {
  realtyUserId?: number | null;
  bannerId: string;
  bannerPlace: string;
  action: 'click' | 'show';
}

export function sendAdsEvent(event: ITeaserEventProps) {
  const config = getConfig();
  const disableSendAdsEvents = !!config.get<boolean>('builders.disableSendAdsEvents');

  const cid = parseCookies(document.cookie)['_CIAN_GK'];
  const teaserApiUrl = getTeaserApiUrl();

  if (!teaserApiUrl || disableSendAdsEvents) {
    return;
  }

  const { action, bannerId, bannerPlace, realtyUserId } = event;

  fetch(teaserApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id: realtyUserId,
      device_type: 'desktop',
      cid,
      pageType: 'Card',
      items: [
        {
          action,
          bannerId,
          bannerPlace,
          timestamp: Date.now(),
          dl: window.location.href,
        },
      ],
    }),
  });
}
